<template>
  <div class="user">
    <div class="photo">
      <img :src="avatar" alt="avatar" />
    </div>
    <div class="user-info">
      <a
        data-toggle="collapse"
        :aria-expanded="!isClosed"
        @click.stop="toggleMenu"
        @click.capture="clicked"
      >
        <span class="font-weight-regular">
          {{ $t("sidebar.mypage") }}
          <b class="caret"></b>
        </span>
      </a>

      <collapse-transition>
        <div v-show="!isClosed">
          <ul class="nav">
            <slot>
              <li>
                <router-link to="/profile/info">
                  <span class="sidebar-mini"
                    ><md-icon>manage_accounts</md-icon></span
                  >
                  <span class="sidebar-normal font-weight-regular">{{
                    $t("sidebar.my_info")
                  }}</span>
                </router-link>
              </li>
              <li>
                <router-link to="/profile/change-password">
                  <span class="sidebar-mini"><md-icon>password</md-icon></span>
                  <span class="sidebar-normal font-weight-regular">{{
                    $t("sidebar.member_change_password")
                  }}</span>
                </router-link>
              </li>
              <li>
                <a>
                  <span class="sidebar-mini">S</span>
                  <span
                    class="sidebar-normal font-weight-regular"
                    @click="hadleLogout"
                    >{{ $t("sidebar.logout") }}</span
                  >
                </a>
              </li>
            </slot>
          </ul>
        </div>
      </collapse-transition>
    </div>
  </div>
</template>
<script>
import { CollapseTransition } from "vue2-transitions";
import { mapActions } from "vuex";

export default {
  components: {
    CollapseTransition,
  },
  props: {
    title: {
      type: String,
      default: "My page",
    },
    rtlTitle: {
      type: String,
      default: "تانيا أندرو",
    },
    avatar: {
      type: String,
      default: "/img/default-avatar.png",
    },
  },
  data() {
    return {
      isClosed: true,
    };
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    clicked: function (e) {
      e.preventDefault();
    },
    toggleMenu: function () {
      this.isClosed = !this.isClosed;
    },
    hadleLogout() {
      this.logout();
      this.$router.push({ path: "/login" });
    },
  },
};
</script>
<style>
.collapsed {
  transition: opacity 1s;
}
</style>
